<template>
    <section class="c-o-section-wysiwyg" :class="`${layoutClasses} ${themeClasses}`" :style="{'background-image': backgroundStyle}">
        <div class="c-o-section-wysiwyg__inner">
            <div v-if="isSideImage" class="c-o-section-wysiwyg__image" :class="{ 'c-o-section-wysiwyg__image--align-right': isRightAligned }">
                <img
                v-if="image"
                :srcset="`${image.sizes.section_medium} 960w, ${image.sizes.section_small} 480w`"
                :sizes="'(max-width: 480px) 480px, 960px'"
                :src="image.sizes.section_medium"
                :alt="image.alt">
            </div>
            <div class="c-o-section-wysiwyg__content">
                <h1 class="c-o-section-wysiwyg__title h2">{{ title }}</h1>
                <p class="c-o-section-wysiwyg__body o-wysiwyg" :class="wysiwygThemeClasses" v-html="body"></p>
                <button-link :label="link.title" :link="link.url" :modifiers="buttonThemeClasses"></button-link>
            </div>
        </div>
    </section>
</template>

<script>
    import filters from '../../../../filters/index.js'
    import ButtonLink from '../../atoms/AtomButtonLink.vue';

    export default {
        filters: filters,
        props:['content', 'data'],
        components: {
            ButtonLink
        },
        data() {
            return{
                title: this.content.title,
                body: this.content.body,
                link: this.content.link,
                image: this.content.image,
                isSideImage: this.content.layout == 'sideImage',
                isNoImage: this.content.layout == 'noImage',
                isBgImage: this.content.layout == 'bgImage',
                isRightAligned: this.content.image_position == 'rightAligned' ? true : false,
            }
        },
        computed: {
            layoutClasses: function(){
                if (this.isBgImage) {
                    return 'c-o-section-wysiwyg--layout-background-image'
                } else if (this.isSideImage) {
                    return 'c-o-section-wysiwyg--layout-side-image'
                } else {
                    return 'c-o-section-wysiwyg--layout-centered'
                }
            },
            themeClasses: function(){
                return `c-o-section-wysiwyg--theme-${this.content.theme}`
            },
            wysiwygThemeClasses: function(){
                return `o-wysiwyg--theme-${this.content.theme}`
            },
            buttonThemeClasses: function() {
                switch (this.content.theme) {
                    case 'secondary':
                        return 'c-a-button--theme-primary '
                    default:
                        return 'c-a-button--theme-secondary '
                }
            },
            backgroundStyle: function() {
                if(this.isBgImage && this.image.url){
                    return `url(${this.image.url})`;
                }
                return '';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/page-sections/OrganismSectionWysiwyg.vue